// Tokens semânticos: a única linguagem de cor que componentes falam. Os valores de cada esquema
// (direção "Rua": limão + tinta) estão em ./rua.ts; o painel web e os apps usam os mesmos.

export type Tom = 'neutro' | 'andamento' | 'sucesso' | 'alerta' | 'erro';

export interface CoresDoTom {
  /** Fundo de selo/aviso. */
  fundo: string;
  /** Texto e ícone sobre `fundo` ou sobre a superfície. */
  texto: string;
  /** Preenchimento cheio (botão "Entreguei") — texto branco por cima. */
  solido: string;
}

export interface Cores {
  fundo: string;
  fundoSutil: string;
  superficie: string;
  superficieElevada: string;
  superficieSelecionada: string;
  borda: string;
  bordaForte: string;
  divisor: string;
  texto: string;
  textoSuave: string;
  textoFraco: string;
  textoDesabilitado: string;
  textoSobreSolido: string;
  /** Fundo do selo do logo: o mesmo par da aba ativa (tinta no claro, limão no escuro). */
  marca: string;
  /** Cubo dentro do selo (limão no claro, tinta no escuro). */
  textoSobreMarca: string;
  /**
   * Texto de destaque da marca (link, "Desfazer", "+ Dividir em duas formas") e ícone solto:
   * tinta no claro, limão no escuro. Limão nunca vira texto sobre fundo claro.
   */
  marcaTexto: string;
  foco: string;
  /** Estrela acesa da avaliação do cliente (link e app do dono). A apagada é `bordaForte`. */
  estrela: string;
  /** Campos e controles (input, select, opção): borda com 3:1 de contraste (WCAG 1.4.11). */
  campoFundo: string;
  campoBorda: string;
  campoBordaHover: string;
  sobreposicao: string;
  /** Faixa escura de destaque (seção de contraste, rodapé de chamada): escura nos dois temas. */
  fundoContraste: string;
  textoContraste: string;
  tons: Record<Tom, CoresDoTom>;
}

export type Esquema = 'claro' | 'escuro';

/** Escala de espaço em px (múltiplos de 4). */
export const espaco = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
} as const;

export const raio = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  pilula: 999,
} as const;

export const tipografia = {
  /** Família provisória: a do sistema. A marca define a definitiva. */
  familia: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  familiaMono: "ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace",
  tamanho: { xs: 12, sm: 13, md: 15, lg: 17, xl: 20, xxl: 26, titulo: 32 },
  peso: { normal: '400', medio: '500', semi: '600', forte: '700' },
  alturaLinha: { justa: 1.2, normal: 1.45 },
} as const;

/** Alvo mínimo de toque (acessibilidade). */
export const ALVO_TOQUE = 44;
/**
 * Folga de toque de um link de texto numa linha (~18 pt de altura): completa os 44 pt na vertical
 * sem mexer no layout.
 */
export const FOLGA_TOQUE_TEXTO = { top: 14, bottom: 14, left: 8, right: 8 } as const;
